import { DispatchedAction } from '../../types/blp-actions';
import { FeatureFlagMap, FeatureFlagsEnum } from '../../types/blp-feature-flags';

export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
type SetFeatureFlagAction = DispatchedAction<typeof SET_FEATURE_FLAGS, FeatureFlagMap>;
export function setFeatureFlags(featureFlags: FeatureFlagMap): SetFeatureFlagAction {
	return {
		type: SET_FEATURE_FLAGS,
		payload: featureFlags,
	};
}

export const TOGGLE_FEATURE_FLAG = 'TOGGLE_FEATURE_FLAG';
type ToggleFeatureFlagAction = DispatchedAction<typeof TOGGLE_FEATURE_FLAG, FeatureFlagsEnum>;
export function toggleFeatureFlag(featureFlag: FeatureFlagsEnum): ToggleFeatureFlagAction {
	return {
		type: TOGGLE_FEATURE_FLAG,
		payload: featureFlag,
	};
}

export type FeatureFlagsActions = SetFeatureFlagAction | ToggleFeatureFlagAction;
